import { ERROR_CODES } from "../utils/constant";
import { eventBus } from "../utils/eventBus";
import { EVENTS } from "../utils/eventTypes";
//import { authService } from "./authService";

let getTokenSilently;
let isUserValid = null;

export const setAuth0TokenGetter = (fn) => {
  getTokenSilently = fn;
};

export const setUserValidated = (value) => {
  isUserValid = value;
};

export const getUserValidated = () => isUserValid;

export const registerRequestInterceptor = (apiClient) => {
  apiClient.interceptors.request.use(
    async (config) => {
      if (isUserValid === false && !config.skipAuthValidation) {
        return Promise.reject("User not validated");
      }

      const token = await getTokenSilently?.();

      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }

      return config;
    },
    (error) => Promise.reject(error),
  );
};

export const setupInterceptors = (apiClient) => {
  apiClient.interceptors.response.use(
    (response) => {
      const backendCode = response?.data?.code;

      if (
        backendCode &&
        backendCode !== ERROR_CODES.SUCCESS &&
        !response.config?.skipGlobalErrorHandler
      ) {
        eventBus.emit(EVENTS.FETCH_API_ERROR, backendCode);
        return Promise.reject(response);
      }
      return response;
    },
    (error) => {
      // ✅ Skip global handling if flagged
      if (error.config?.skipGlobalErrorHandler) {
        return Promise.reject(error);
      }

      let errorCode = error?.response?.data?.code;

      // Handle timeout (ECONNABORTED)
      if (!errorCode && error?.code === "ECONNABORTED") {
        errorCode = 30001;
      }

      eventBus.emit(EVENTS.FETCH_API_ERROR, errorCode);

      return Promise.reject(error);
    },
  );
};

export const registerBrowserInterceptor = (apiClient) => {
  apiClient.interceptors.request.use(
    async (config) => {
      if (navigator.userAgentData?.getHighEntropyValues) {
        try {
          const data = await navigator.userAgentData.getHighEntropyValues([
            "fullVersionList",
          ]);

          if (data.fullVersionList && data.fullVersionList.length > 0) {
            const fullVersion = data.fullVersionList[0].version;
            config.headers["X-Full-Browser-Version"] = fullVersion;
          }
        } catch (e) {
          console.error("UA-CH error:", e);
        }
      }

      return config;
    },
    (error) => Promise.reject(error),
  );
};
